import styled from "@emotion/styled";
import { FollowUsOnFacebook } from "scmp-sdk/components/follow-us-on-facebook";
import { FacebookIframe } from "scmp-sdk/components/follow-us-on-facebook/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import IconTickCircle from "./icon-tick-circle.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  ${theme.breakpoints.down("tablet")} {
    align-items: center;
  }
`;

export const StyledIconTickCircle = styled(IconTickCircle)`
  inline-size: 25px;
  block-size: 25px;
`;

type TitleProps = {
  theme?: ThemeType;
};
export const Title = styled.div<TitleProps>`
  margin-block-start: 20px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: normal;
  text-align: start;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 15px;
    padding-inline: 16px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: space-between;

  inline-size: 100%;

  ${theme.breakpoints.down("tablet")} {
    display: flex;
    flex-direction: column;
    gap: 20px;

    max-inline-size: 500px;
  }
`;

export const ContentContainer = styled.div`
  ${theme.breakpoints.up("tablet")} {
    display: flex;
    align-items: center;
  }
`;

export const StyledFollowUsOnFacebook = styled(FollowUsOnFacebook)`
  display: block;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  ${FacebookIframe} {
    inline-size: 86px;
    margin-inline-start: 0;

    ${theme.breakpoints.down("tablet")} {
      margin-block-start: 4px;
    }
  }
`;

type CheckEmailMessageProps = {
  theme?: ThemeType;
};

export const CheckEmailMessage = styled.div<CheckEmailMessageProps>`
  margin-block-start: 8px;

  color: #000000;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: normal;
  text-align: start;
  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 4px;
  }
`;
